import React, { useState } from "react";
import MyModal from "../Common/MyModal";
import MyIcon from "../Common/MyIcon";
import PurchaseIcon from "../../assets/icons/Icon_Library/application icons/reports/billing.svg2";
import { Button, ModalBody } from "react-bootstrap";
import { usePurchaseSolutionMutation } from "../store/slices/settingsSlice";

import SolutionPurchaseOptions from "../Dashboard/SolutionPurchaseOptions";

export default function SolutionPurchaseModal({ solution }) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-4">
      <div className="mb-3 fw-bold">TBC...</div>

      <div className="my-3">
        <SolutionPurchaseOptions solution={solution} />
      </div>
    </div>
  );
}
